import { render, staticRenderFns } from "./general_widgets.vue?vue&type=template&id=e598a06a&"
import script from "./general_widgets.vue?vue&type=script&lang=js&"
export * from "./general_widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports